import styled, {css} from 'styled-components'
import {H1, H2, H3, H4, H5, P, Small} from '@modifi/ui'
import {airBlue} from '@modifi/colors'

export {H1, H2, H3, H4, H5, P, Small}

export const A = styled.a`
  color: ${({color = airBlue}) => color};
  text-decoration: ${({underline}) => (underline ? 'underline' : 'none')};
  ${({margin}) =>
    margin
      ? css`
          display: block;
          margin: ${margin};
        `
      : ''};
`

export const Pre = styled(P)`
  white-space: pre;
`
